import React from "react";
import HeaderAll from "../components/HeaderAll";
import { Container, Row, Col } from "react-bootstrap";

import "../css/Checkout.css";
import Subtotal from "../components/Subtotal";
import Checkoutproduct from "../components/Checkoutproduct";
import { useStateValue } from "../Stateprovider";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const stripePromise = loadStripe("pk_test_S8fjcr4d4Z1UTixPjGufaYMS");

function Checkout() {
  const [{ basket }, dispatch] = useStateValue();

  return (
    <div className="checkout">
      <HeaderAll></HeaderAll>
      {/* <Container>Ad Goes here</Container> */}
      <br></br>
      <Container>
        <Row>
          <Col sm={{ order: 1 }}>
            <h2>Your Cart</h2>

            {basket.map((item) => (
              <Checkoutproduct
                id={item.id}
                projectTitle={item.title}
                price={item.price}
                description={item.description}
                image={item.image}
              ></Checkoutproduct>
            ))}
          </Col>
          <Col sm={{ order: 2 }}>
            <Elements stripe={stripePromise}>
              <Subtotal></Subtotal>
            </Elements>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Checkout;
